import { httpClient } from '@/network/clientController'

/** Get Recurring transfers list for a specific account
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_transfersrecurring
*/
export const requestRecurringTransfers = (params) => {
    return httpClient({
		method: 'GET',
		url: 'transfers/recurring',
        params: params,
		isCancellable: true
	})
}

/** Create recurring transfer for a specific account
@docs Não há documentação
*/
export const createRecurringTransfer = (payload) => {
	return httpClient({
		method: 'POST',
		url: 'transfers/recurring/create',
		data: payload,
		operationTypeId: 107 /* for mocks handling of tokens */
	})
}

/** Edit recurring transfer for a specific account
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_transfersrecurringedit%7BaccountId%7D%7BtransferId%7D
*/
export const editRecurringTransfer = ({ accountId, transferId, data }) => {
	return httpClient({
		method: 'PUT',
		url: `transfers/recurring/edit/${accountId}/${transferId}`,
		data: data,
		operationTypeId: 1092 /* for mocks handling of tokens */
	})
}

/** Deletes recurring transfer for a specific account
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/DELETE_transfersrecurring%7BaccountId%7D%7BtransferId%7D
*/
export const deleteRecurringTransfer = ({ accountId, transferId }) => {
	return httpClient({
		method: 'DELETE',
		url: `transfers/recurring/${accountId}/${transferId}`,
		operationTypeId: 18005 /* for mocks handling of tokens */
	})
}
